import React from "react";
import LoaderHandler from "../shared/LoaderHandler";

interface Props {
  children: any;
}
//dummy table data having columns "affected stores","channels","reason","type","date","action"
const dummyData = [
  {
    id: 1,
    affectedStores: "Flipopia",
    channels: "google.fr",
    reason: "Plexiglass",
    type: "Services",
    timestamp: "2022-08-22 04:23:31",
  },
  {
    id: 2,
    affectedStores: "Gigabox",
    channels: "thetimes.co.uk",
    reason: "Rubber",
    type: "Accounting",
    timestamp: "2022-08-22 04:23:30",
  },
  {
    id: 3,
    affectedStores: "Realmix",
    channels: "stumbleupon.com",
    reason: "Wood",
    type: "Human Resources",
    timestamp: "2022-09-20 05:39:17",
  },
  {
    id: 4,
    affectedStores: "Centizu",
    channels: "umn.edu",
    reason: "Rubber",
    type: "Product Management",
    timestamp: "2022-09-02 05:51:18",
  },
  {
    id: 5,
    affectedStores: "Vinder",
    channels: "opensource.org",
    reason: "Rubber",
    type: "Marketing",
    timestamp: "2022-07-19 11:57:55",
  },
  {
    id: 6,
    affectedStores: "Jabbersphere",
    channels: "linkedin.com",
    reason: "Steel",
    type: "Business Development",
    timestamp: "2022-08-10 21:33:41",
  },
  {
    id: 7,
    affectedStores: "Brightdog",
    channels: "un.org",
    reason: "Steel",
    type: "Sales",
    timestamp: "2022-08-23 23:27:49",
  },
  {
    id: 8,
    affectedStores: "Photofeed",
    channels: "pen.io",
    reason: "Vinyl",
    type: "Services",
    timestamp: "2022-09-21 16:17:02",
  },
  {
    id: 9,
    affectedStores: "Leexo",
    channels: "hostgator.com",
    reason: "Granite",
    type: "Marketing",
    timestamp: "2022-06-14 21:42:51",
  },
  {
    id: 10,
    affectedStores: "Riffpath",
    channels: "pinterest.com",
    reason: "Plexiglass",
    type: "Accounting",
    timestamp: "2022-08-28 14:39:01",
  },
  {
    id: 11,
    affectedStores: "Cogibox",
    channels: "princeton.edu",
    reason: "Plexiglass",
    type: "Engineering",
    timestamp: "2022-07-09 04:41:44",
  },
  {
    id: 12,
    affectedStores: "Dynabox",
    channels: "umich.edu",
    reason: "Granite",
    type: "Support",
    timestamp: "2022-07-03 05:14:53",
  },
  {
    id: 13,
    affectedStores: "Eayo",
    channels: "surveymonkey.com",
    reason: "Brass",
    type: "Human Resources",
    timestamp: "2022-06-14 05:01:44",
  },
  {
    id: 14,
    affectedStores: "Skyba",
    channels: "goo.gl",
    reason: "Stone",
    type: "Support",
    timestamp: "2022-09-01 10:20:53",
  },
  {
    id: 15,
    affectedStores: "Meetz",
    channels: "opensource.org",
    reason: "Plexiglass",
    type: "Product Management",
    timestamp: "2022-06-27 19:13:16",
  },
  {
    id: 16,
    affectedStores: "Thoughtbridge",
    channels: "last.fm",
    reason: "Glass",
    type: "Legal",
    timestamp: "2022-09-07 01:48:40",
  },
  {
    id: 17,
    affectedStores: "Devpoint",
    channels: "moonfruit.com",
    reason: "Wood",
    type: "Human Resources",
    timestamp: "2022-08-14 21:19:30",
  },
  {
    id: 18,
    affectedStores: "Bluejam",
    channels: "columbia.edu",
    reason: "Granite",
    type: "Human Resources",
    timestamp: "2022-08-27 07:43:54",
  },
  {
    id: 19,
    affectedStores: "Realcube",
    channels: "is.gd",
    reason: "Plexiglass",
    type: "Business Development",
    timestamp: "2022-09-20 18:09:01",
  },
  {
    id: 20,
    affectedStores: "Oyoba",
    channels: "example.com",
    reason: "Aluminum",
    type: "Product Management",
    timestamp: "2022-07-13 17:21:35",
  },
  {
    id: 21,
    affectedStores: "Yata",
    channels: "chron.com",
    reason: "Plexiglass",
    type: "Product Management",
    timestamp: "2022-07-18 01:16:43",
  },
  {
    id: 22,
    affectedStores: "Thoughtbridge",
    channels: "jiathis.com",
    reason: "Glass",
    type: "Human Resources",
    timestamp: "2022-07-03 16:17:20",
  },
  {
    id: 23,
    affectedStores: "Realbridge",
    channels: "purevolume.com",
    reason: "Granite",
    type: "Research and Development",
    timestamp: "2022-07-09 19:55:48",
  },
  {
    id: 24,
    affectedStores: "Rhynoodle",
    channels: "bloomberg.com",
    reason: "Rubber",
    type: "Marketing",
    timestamp: "2022-07-10 10:40:09",
  },
  {
    id: 25,
    affectedStores: "Mydeo",
    channels: "sogou.com",
    reason: "Plexiglass",
    type: "Product Management",
    timestamp: "2022-08-09 05:34:13",
  },
  {
    id: 26,
    affectedStores: "Meedoo",
    channels: "weebly.com",
    reason: "Brass",
    type: "Business Development",
    timestamp: "2022-06-27 18:37:20",
  },
  {
    id: 27,
    affectedStores: "Eadel",
    channels: "ed.gov",
    reason: "Vinyl",
    type: "Accounting",
    timestamp: "2022-07-21 15:22:56",
  },
  {
    id: 28,
    affectedStores: "Realcube",
    channels: "thetimes.co.uk",
    reason: "Aluminum",
    type: "Training",
    timestamp: "2022-09-23 02:35:28",
  },
  {
    id: 29,
    affectedStores: "Babbleopia",
    channels: "xinhuanet.com",
    reason: "Vinyl",
    type: "Sales",
    timestamp: "2022-06-28 00:41:14",
  },
  {
    id: 30,
    affectedStores: "Trilith",
    channels: "usgs.gov",
    reason: "Glass",
    type: "Human Resources",
    timestamp: "2022-06-19 10:49:41",
  },
  {
    id: 31,
    affectedStores: "Aimbo",
    channels: "arizona.edu",
    reason: "Brass",
    type: "Engineering",
    timestamp: "2022-10-01 02:45:53",
  },
  {
    id: 32,
    affectedStores: "Pixonyx",
    channels: "printfriendly.com",
    reason: "Wood",
    type: "Services",
    timestamp: "2022-08-07 18:33:31",
  },
  {
    id: 33,
    affectedStores: "Devpoint",
    channels: "blogger.com",
    reason: "Vinyl",
    type: "Product Management",
    timestamp: "2022-06-22 19:46:47",
  },
  {
    id: 34,
    affectedStores: "Roomm",
    channels: "hexun.com",
    reason: "Wood",
    type: "Research and Development",
    timestamp: "2022-09-04 15:11:25",
  },
  {
    id: 35,
    affectedStores: "Jabbertype",
    channels: "uiuc.edu",
    reason: "Steel",
    type: "Training",
    timestamp: "2022-08-09 03:48:53",
  },
  {
    id: 36,
    affectedStores: "Blogpad",
    channels: "smugmug.com",
    reason: "Steel",
    type: "Services",
    timestamp: "2022-06-28 16:43:31",
  },
  {
    id: 37,
    affectedStores: "Zoomlounge",
    channels: "hud.gov",
    reason: "Steel",
    type: "Product Management",
    timestamp: "2022-07-15 03:43:55",
  },
  {
    id: 38,
    affectedStores: "Gabtype",
    channels: "163.com",
    reason: "Steel",
    type: "Product Management",
    timestamp: "2022-09-22 15:15:43",
  },
  {
    id: 39,
    affectedStores: "Gigaclub",
    channels: "is.gd",
    reason: "Plexiglass",
    type: "Accounting",
    timestamp: "2022-06-13 06:49:15",
  },
  {
    id: 40,
    affectedStores: "Flashspan",
    channels: "parallels.com",
    reason: "Stone",
    type: "Human Resources",
    timestamp: "2022-06-22 20:58:28",
  },
  {
    id: 41,
    affectedStores: "Livepath",
    channels: "aboutads.info",
    reason: "Vinyl",
    type: "Product Management",
    timestamp: "2022-07-08 04:12:46",
  },
  {
    id: 42,
    affectedStores: "Quimm",
    channels: "wix.com",
    reason: "Rubber",
    type: "Accounting",
    timestamp: "2022-08-10 11:23:25",
  },
  {
    id: 43,
    affectedStores: "Leexo",
    channels: "usa.gov",
    reason: "Plexiglass",
    type: "Marketing",
    timestamp: "2022-07-17 01:07:35",
  },
  {
    id: 44,
    affectedStores: "Skyndu",
    channels: "wsj.com",
    reason: "Granite",
    type: "Business Development",
    timestamp: "2022-06-18 19:24:30",
  },
  {
    id: 45,
    affectedStores: "Meevee",
    channels: "nba.com",
    reason: "Rubber",
    type: "Training",
    timestamp: "2022-09-19 05:09:54",
  },
  {
    id: 46,
    affectedStores: "Photobug",
    channels: "sina.com.cn",
    reason: "Plexiglass",
    type: "Training",
    timestamp: "2022-06-26 17:14:02",
  },
  {
    id: 47,
    affectedStores: "Agimba",
    channels: "example.com",
    reason: "Wood",
    type: "Product Management",
    timestamp: "2022-08-11 18:38:52",
  },
  {
    id: 48,
    affectedStores: "Youtags",
    channels: "theglobeandmail.com",
    reason: "Brass",
    type: "Engineering",
    timestamp: "2022-06-23 02:27:55",
  },
  {
    id: 49,
    affectedStores: "Feedbug",
    channels: "friendfeed.com",
    reason: "Stone",
    type: "Product Management",
    timestamp: "2022-07-27 02:53:24",
  },
  {
    id: 50,
    affectedStores: "Yakijo",
    channels: "nasa.gov",
    reason: "Granite",
    type: "Engineering",
    timestamp: "2022-07-13 11:12:37",
  },
  {
    id: 51,
    affectedStores: "Topdrive",
    channels: "addthis.com",
    reason: "Rubber",
    type: "Services",
    timestamp: "2022-09-20 08:10:38",
  },
  {
    id: 52,
    affectedStores: "Voonder",
    channels: "zimbio.com",
    reason: "Steel",
    type: "Accounting",
    timestamp: "2022-07-18 22:29:57",
  },
  {
    id: 53,
    affectedStores: "Abatz",
    channels: "friendfeed.com",
    reason: "Wood",
    type: "Business Development",
    timestamp: "2022-07-06 01:56:17",
  },
  {
    id: 54,
    affectedStores: "Wordify",
    channels: "earthlink.net",
    reason: "Glass",
    type: "Human Resources",
    timestamp: "2022-08-10 10:26:30",
  },
  {
    id: 55,
    affectedStores: "Yata",
    channels: "jugem.jp",
    reason: "Steel",
    type: "Legal",
    timestamp: "2022-08-06 14:25:32",
  },
  {
    id: 56,
    affectedStores: "Plambee",
    channels: "privacy.gov.au",
    reason: "Stone",
    type: "Product Management",
    timestamp: "2022-08-17 11:40:32",
  },
  {
    id: 57,
    affectedStores: "Abata",
    channels: "tripadvisor.com",
    reason: "Vinyl",
    type: "Business Development",
    timestamp: "2022-08-16 23:36:19",
  },
  {
    id: 58,
    affectedStores: "Podcat",
    channels: "un.org",
    reason: "Rubber",
    type: "Engineering",
    timestamp: "2022-06-13 05:10:21",
  },
  {
    id: 59,
    affectedStores: "Twitterwire",
    channels: "webmd.com",
    reason: "Brass",
    type: "Research and Development",
    timestamp: "2022-08-17 11:30:48",
  },
  {
    id: 60,
    affectedStores: "Vinte",
    channels: "merriam-webster.com",
    reason: "Rubber",
    type: "Accounting",
    timestamp: "2022-07-21 16:25:15",
  },
  {
    id: 61,
    affectedStores: "Realfire",
    channels: "ustream.tv",
    reason: "Wood",
    type: "Business Development",
    timestamp: "2022-07-11 17:57:49",
  },
  {
    id: 62,
    affectedStores: "Photobean",
    channels: "npr.org",
    reason: "Plexiglass",
    type: "Training",
    timestamp: "2022-07-05 11:22:51",
  },
  {
    id: 63,
    affectedStores: "Quinu",
    channels: "arstechnica.com",
    reason: "Granite",
    type: "Human Resources",
    timestamp: "2022-09-20 22:33:24",
  },
  {
    id: 64,
    affectedStores: "Skalith",
    channels: "unblog.fr",
    reason: "Brass",
    type: "Accounting",
    timestamp: "2022-06-23 12:05:36",
  },
  {
    id: 65,
    affectedStores: "Flashspan",
    channels: "mapy.cz",
    reason: "Rubber",
    type: "Services",
    timestamp: "2022-08-01 18:44:09",
  },
  {
    id: 66,
    affectedStores: "Browsezoom",
    channels: "java.com",
    reason: "Rubber",
    type: "Training",
    timestamp: "2022-09-06 17:57:56",
  },
  {
    id: 67,
    affectedStores: "Wikido",
    channels: "japanpost.jp",
    reason: "Glass",
    type: "Human Resources",
    timestamp: "2022-08-02 06:04:46",
  },
  {
    id: 68,
    affectedStores: "Tagopia",
    channels: "yahoo.co.jp",
    reason: "Glass",
    type: "Training",
    timestamp: "2022-07-02 18:11:51",
  },
  {
    id: 69,
    affectedStores: "Abatz",
    channels: "stanford.edu",
    reason: "Granite",
    type: "Human Resources",
    timestamp: "2022-08-30 22:56:45",
  },
  {
    id: 70,
    affectedStores: "Cogilith",
    channels: "utexas.edu",
    reason: "Brass",
    type: "Training",
    timestamp: "2022-09-12 21:10:45",
  },
  {
    id: 71,
    affectedStores: "Babbleset",
    channels: "google.co.uk",
    reason: "Granite",
    type: "Support",
    timestamp: "2022-07-22 11:04:37",
  },
  {
    id: 72,
    affectedStores: "Bubbletube",
    channels: "vkontakte.ru",
    reason: "Plastic",
    type: "Product Management",
    timestamp: "2022-07-10 23:31:24",
  },
  {
    id: 73,
    affectedStores: "Myworks",
    channels: "so-net.ne.jp",
    reason: "Vinyl",
    type: "Services",
    timestamp: "2022-06-20 19:45:35",
  },
  {
    id: 74,
    affectedStores: "Realbuzz",
    channels: "usa.gov",
    reason: "Glass",
    type: "Marketing",
    timestamp: "2022-09-07 14:34:25",
  },
  {
    id: 75,
    affectedStores: "Jabbertype",
    channels: "is.gd",
    reason: "Glass",
    type: "Services",
    timestamp: "2022-08-23 02:03:24",
  },
  {
    id: 76,
    affectedStores: "Agivu",
    channels: "arstechnica.com",
    reason: "Aluminum",
    type: "Business Development",
    timestamp: "2022-06-16 10:26:43",
  },
  {
    id: 77,
    affectedStores: "Quamba",
    channels: "harvard.edu",
    reason: "Brass",
    type: "Research and Development",
    timestamp: "2022-10-03 01:16:26",
  },
  {
    id: 78,
    affectedStores: "Wikido",
    channels: "tripod.com",
    reason: "Plexiglass",
    type: "Services",
    timestamp: "2022-08-11 00:09:21",
  },
  {
    id: 79,
    affectedStores: "Ailane",
    channels: "buzzfeed.com",
    reason: "Aluminum",
    type: "Research and Development",
    timestamp: "2022-08-24 16:36:17",
  },
  {
    id: 80,
    affectedStores: "Kwinu",
    channels: "linkedin.com",
    reason: "Granite",
    type: "Business Development",
    timestamp: "2022-07-09 09:58:48",
  },
  {
    id: 81,
    affectedStores: "Voolith",
    channels: "angelfire.com",
    reason: "Aluminum",
    type: "Research and Development",
    timestamp: "2022-07-03 02:48:13",
  },
  {
    id: 82,
    affectedStores: "BlogXS",
    channels: "multiply.com",
    reason: "Granite",
    type: "Product Management",
    timestamp: "2022-09-25 06:14:20",
  },
  {
    id: 83,
    affectedStores: "Thoughtblab",
    channels: "addthis.com",
    reason: "Steel",
    type: "Product Management",
    timestamp: "2022-06-12 19:16:14",
  },
  {
    id: 84,
    affectedStores: "Trupe",
    channels: "theguardian.com",
    reason: "Wood",
    type: "Legal",
    timestamp: "2022-09-07 12:12:59",
  },
  {
    id: 85,
    affectedStores: "Blogpad",
    channels: "paginegialle.it",
    reason: "Brass",
    type: "Research and Development",
    timestamp: "2022-06-26 01:18:16",
  },
  {
    id: 86,
    affectedStores: "Zava",
    channels: "tinypic.com",
    reason: "Steel",
    type: "Accounting",
    timestamp: "2022-09-22 01:30:40",
  },
  {
    id: 87,
    affectedStores: "Jazzy",
    channels: "wufoo.com",
    reason: "Aluminum",
    type: "Services",
    timestamp: "2022-08-13 05:58:35",
  },
  {
    id: 88,
    affectedStores: "Oba",
    channels: "arizona.edu",
    reason: "Brass",
    type: "Services",
    timestamp: "2022-10-06 01:14:11",
  },
  {
    id: 89,
    affectedStores: "Zoovu",
    channels: "soundcloud.com",
    reason: "Stone",
    type: "Marketing",
    timestamp: "2022-06-27 12:45:08",
  },
  {
    id: 90,
    affectedStores: "Edgetag",
    channels: "elpais.com",
    reason: "Steel",
    type: "Sales",
    timestamp: "2022-08-08 12:43:38",
  },
  {
    id: 91,
    affectedStores: "Aibox",
    channels: "google.co.uk",
    reason: "Wood",
    type: "Support",
    timestamp: "2022-08-21 13:39:43",
  },
  {
    id: 92,
    affectedStores: "DabZ",
    channels: "wikia.com",
    reason: "Plexiglass",
    type: "Support",
    timestamp: "2022-07-29 01:39:48",
  },
  {
    id: 93,
    affectedStores: "Oyoloo",
    channels: "simplemachines.org",
    reason: "Glass",
    type: "Accounting",
    timestamp: "2022-06-16 17:27:13",
  },
  {
    id: 94,
    affectedStores: "Realcube",
    channels: "china.com.cn",
    reason: "Stone",
    type: "Business Development",
    timestamp: "2022-06-20 02:45:23",
  },
  {
    id: 95,
    affectedStores: "Tagfeed",
    channels: "usatoday.com",
    reason: "Vinyl",
    type: "Product Management",
    timestamp: "2022-07-14 04:33:06",
  },
  {
    id: 96,
    affectedStores: "Thoughtbridge",
    channels: "ftc.gov",
    reason: "Vinyl",
    type: "Engineering",
    timestamp: "2022-09-13 18:34:53",
  },
  {
    id: 97,
    affectedStores: "Mynte",
    channels: "disqus.com",
    reason: "Rubber",
    type: "Business Development",
    timestamp: "2022-06-22 22:13:26",
  },
  {
    id: 98,
    affectedStores: "Quamba",
    channels: "parallels.com",
    reason: "Steel",
    type: "Sales",
    timestamp: "2022-07-06 12:45:48",
  },
  {
    id: 99,
    affectedStores: "Gabspot",
    channels: "zimbio.com",
    reason: "Glass",
    type: "Services",
    timestamp: "2022-09-23 12:01:06",
  },
  {
    id: 100,
    affectedStores: "Midel",
    channels: "nbcnews.com",
    reason: "Plexiglass",
    type: "Product Management",
    timestamp: "2022-08-28 21:36:07",
  },
];
export const AlertListControlDataHandler = ({ children }: Props) => {
  return (
    <LoaderHandler loading={false} error={null}>
      {children(dummyData)}
    </LoaderHandler>
  );
};
